<template>
    <v-container>
        <v-row
            align="center"
            justify="center"
        >
            <v-col cols="8">
                <v-card outlined class="mx-auto" max-width="600">
                    <v-card-subtitle>
                        Crear usuario
                    </v-card-subtitle>
                    <v-card-text>
                        <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation
                        >
                            <v-row align="center" justify="center">
                                <v-col cols="3">
                                    <v-checkbox
                                        v-model="roles"
                                        color="success"
                                        label="Usuario"
                                        value="user"
                                        readonly
                                    ></v-checkbox>
                                </v-col>
                                <v-col cols="3">
                                    <v-checkbox
                                        v-model="roles"
                                        color="success"
                                        label="Reporter"
                                        value="reporter"
                                    ></v-checkbox>
                                </v-col>
                                <v-col cols="3">
                                    <v-checkbox
                                        v-model="roles"
                                        color="success"
                                        label="Mantenedor"
                                        value="maintainer"
                                    ></v-checkbox>
                                </v-col>
                                <v-col cols="3">
                                    <v-checkbox
                                        v-if="isDev"
                                        v-model="roles"
                                        color="success"
                                        label="Administrador"
                                        value="admin"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row align="center" justify="center">
                                <v-col cols="3">
                                    <v-checkbox
                                        v-if="isDev"
                                        v-model="roles"
                                        color="success"
                                        label="Desarrollador"
                                        value="dev"
                                    ></v-checkbox>
                                </v-col>
                                <v-col cols="3">
                                    <v-checkbox
                                        v-if="isDev"
                                        v-model="roles"
                                        color="success"
                                        label="Ventas"
                                        value="preview"
                                    ></v-checkbox>
                                </v-col>
                                <v-col cols="3">
                                    <v-checkbox
                                        v-if="isDev"
                                        v-model="roles"
                                        color="success"
                                        label="DUMMY - Experimental!!"
                                        value="dummy"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>

                            <v-combobox
                                    v-model="select"
                                    :items="projects"
                                    item-text="name"
                                    label="Proyectos"
                                    dense
                                    outlined
                                    persistent-hint
                            ></v-combobox>
                            <v-text-field
                                v-model="newUserEmail"
                                outlined
                                dense
                                clearable
                                label="Correo electronico"
                                hint="Correo electronico"
                                :rules="emailRules"
                                required
                            ></v-text-field>
                            <v-btn
                                color="green"
                                outlined
                                @click="sendEmail"
                                :disabled="!valid"
                            >
                                Enviar
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
	import moment from 'moment'

	export default {
        name: 'Users',
        

		data: () => ({
            newUserEmail: '',
            select: null,
            valid: false,
            roles: ['user'],
            emailRules: [
                v => !!v || 'E-mail es requerido',
                v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
            ],
		}),
		
		methods: {
			sendEmail () {
                let payload = {
                    email: this.newUserEmail,
                    projectId: this.select.projectId,
                    roles: []
                }

                this.roles.forEach( e => {
                    payload.roles.push({
                        name: e
                    })
                })

                const isValid = this.$refs.form.validate()
                const validProjectId = typeof payload.projectId === 'string'
   
                if (isValid && validProjectId)
                    this.$store.dispatch('sendEmailRegister', payload)
            }
		},

		computed: {
            user () {
                return this.$store.getters.user
            },
            projects () {
                return this.$store.getters.projects
            },
            isLoading () {
                return this.$store.getters.loadRegister
            },
            errorRegister () {
                return this.$store.getters.errorRegister
            },
            successRegister () {
                return this.$store.getters.successRegister
            },
            isDev () {
                return this.user.roles.some( e => {
                    return e.name === 'dev'
                })
            }
		},

		filters : {

		},

		created () {
			moment.locale('es-us')
		}

	}
</script>
